export const enum MutationNames {
  updateUnitRoundReport = 'UNIT_ROUND_REPORT_UPDATE_UNIT_ROUND_REPORT',
  updateChosenOneMonthPeriod = 'UNIT_ROUND_REPORT_UPDATE_CHOSEN_ONE_MONTH_PERIOD',
  updateChosenTwoWeekPeriod = 'UNIT_ROUND_REPORT_UPDATE_CHOSEN_TWO_WEEK_PERIOD',
  updateChosenReportPeriod = 'UNIT_ROUND_REPORT_UPDATE_CHOSEN_REPORT_PERIOD',
}

export const enum ActionNames {
  getUnitRoundReportByTimestamps = 'UNIT_ROUND_REPORT_GET_UNIT_ROUND_REPORT_BY_TIMESTAMPS',
}

export const enum GetterNames {
  unitRoundReport = 'UNIT_ROUND_REPORT_UNIT_ROUND_REPORT',
  chosenOneMonthPeriod = 'UNIT_ROUND_REPORT_CHOSEN_ONE_MONTH_PERIOD',
  chosenTwoWeekPeriod = 'UNIT_ROUND_REPORT_CHOSEN_TWO_WEEK_PERIOD',
  chosenReportPeriod = 'UNIT_ROUND_REPORT_CHOSEN_REPORT_PERIOD',
}
